import axios from 'axios'
import endpoint from '../../../utils/endpoint'

export const getReadingEase = async text => {
    try {
        return axios.post(
            `${endpoint.getServiceEndpoint(process.env.NODE_ENV)}/readability`,
            { text: text },
        )
    } catch (error) {
        console.log(error)
    }
}
